import { render, staticRenderFns } from "./user-edit.vue?vue&type=template&id=192d06fa&"
import script from "./user-edit.vue?vue&type=script&lang=js&"
export * from "./user-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports